<ng-container *ngIf="disableMultiSelect; else multiSelect">
  <osn-cxb-single-select
    *ngIf="genresControl"
    [formControl]="genresControl"
    [options]="genreSingleSelectOptions"
    filterPlaceholderLabel="Filter in genres..."
    placeholder="Filter in genres..."
    filterNoEntriesFoundLabel="No genres found"
    [data-testid]="testId"
  ></osn-cxb-single-select>
</ng-container>
<ng-template #multiSelect>
  <osn-cxb-multi-select
    *ngIf="genresControl"
    [formControl]="genresControl"
    [allowMultiLine]="false"
    [options]="genres"
    filterPlaceholderLabel="Filter in genres..."
    placeholder="Filter in genres..."
    filterNoEntriesFoundLabel="No genres found"
    [data-testid]="testId"
  ></osn-cxb-multi-select>
</ng-template>
